import { useLocation, useNavigate } from 'react-router-dom';
import {
  useBroadcastSwitcher,
  useRecognitionSwitcher,
  useTaskSwitcher,
} from 'hooks';
import { setDraftTask, useTaskStore } from 'store/task';
import { useLeaveTaskGroupsModal } from 'hooks/context/use-leave-task-groups-modal';
import { taskRoutes } from 'router/taskRoutes';
import { taskManagementRoutes } from 'router/taskManagementRoutes';
import { broadcastRoutes } from 'router/broadcastRoutes';
import { recognitionRoutes } from 'router/recognitionRoutes';
import { useCallback } from 'react';

export function useNavigationHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const switchTask = useTaskSwitcher();
  const switchRecognition = useRecognitionSwitcher();
  const switchBroadcast = useBroadcastSwitcher();
  const { draft: draftTask, assignedGroup } = useTaskStore();
  const leaveTaskGroups = useLeaveTaskGroupsModal();

  return useCallback(
    (link: string) => {
      if (location.pathname === link) return;

      if (location.pathname.includes(taskManagementRoutes.taskGroups)) {
        return leaveTaskGroups({
          onSuccess: () => {
            navigate(link);
          },
          onAbort: () => {
            navigate(link);
          },
        });
      }

      if (location.pathname.includes(recognitionRoutes.base)) {
        return switchRecognition({
          onSuccess: () => {
            navigate(link);
          },
          onAbort: () => {
            navigate(link);
          },
        });
      }

      if (location.pathname.includes(broadcastRoutes.base)) {
        return switchBroadcast({
          onSuccess: () => {
            navigate(link);
          },
          onAbort: () => {
            navigate(link);
          },
        });
      }

      if (location.pathname.includes(taskRoutes.base)) {
        return switchTask({
          onSuccess: () => {
            if (draftTask) {
              draftTask.status = 'DRAFT';
              setDraftTask({ task: draftTask, assignedGroup });
            }
            navigate(link);
          },
          onAbort: () => {
            navigate(link);
          },
        });
      }

      return navigate(link);
    },
    [
      location.pathname,
      navigate,
      leaveTaskGroups,
      switchRecognition,
      switchBroadcast,
      switchTask,
      draftTask,
      assignedGroup,
    ],
  );
}
